export function printPrescriptionImg(imgSrc) {
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    document.body.appendChild(iframe);


    iframe.contentDocument.write(`
      <html>
        <head>
          <title>打印处方</title>
          <style>
            @media print {
              img {
                width: 100%;
                height: auto;
                image-rendering: -webkit-optimize-contrast;
                image-rendering: crisp-edges;
              }
              body {
                margin: 0;
                padding: 0;
              }
            }
          </style>
        </head>
        <body>
          <img src="${imgSrc}" />
        </body>
        <script>
          window.onload = function() {
            setTimeout(function() {
              window.print();
              window.close();
            }, 1000);
          };
        <\/script>
      </html>
    `);

    iframe.contentDocument.close();

    setTimeout(() => {
        document.body.removeChild(iframe);
    }, 1500);
}